// extracted by mini-css-extract-plugin
module.exports = {"jds-CardHeader":"cardHeader_jds-CardHeader__wn2UV","jds-CardHeader--hasPadding":"cardHeader_jds-CardHeader--hasPadding__D6XZ8"};